// Small helpers of the history page (spec/dashboard.md section 12.1).
import { ApiError } from '../../api/client';
import type { Branch } from '../../api/types';

export const ROW_HEIGHT = 36;
export const PAGE_SIZE = 50;
export const PROTECTED_TEXT = 'This branch is protected: changes land through merge requests.';
export const CONFLICT_TEXT = 'Resolve through a merge request from a branch.';

export const shortSha = (sha: string | null | undefined) => (sha ? sha.slice(0, 8) : '');

/** The first line of a commit message. */
export const subjectOf = (message: string | null | undefined) => (message ?? '').split(/\r?\n/, 1)[0] ?? '';

export function errorText(e: unknown): string {
  if (e instanceof ApiError) return e.requestId ? `${e.message} (request ${e.requestId})` : e.message;
  return e instanceof Error ? e.message : String(e);
}

/** The branch name rule of spec/api-conventions.md section 1; null when the name is acceptable. */
export function branchNameError(name: string, branches: Branch[], current?: string): string | null {
  if (name.length === 0) return 'A name is required.';
  if (!/^[a-z0-9][a-z0-9._/-]{0,98}$/.test(name)) return 'Lower-case letters, digits, ".", "_", "/" and "-", starting with a letter or a digit, at most 99 characters.';
  if (name.includes('..')) return 'A name cannot contain "..".';
  if (name.endsWith('/')) return 'A name cannot end with "/".';
  if (name !== current && branches.some((b) => b.name === name)) return 'A branch with this name exists.';
  return null;
}

/** A conflict as the dialogs list it: the path and the conflicting fields (or the server's message). */
export interface ConflictLine {
  path: string;
  fields: string[];
  message?: string;
}

/** The conflicting paths of a `409` (one detail per path, `field` = the path). */
export function conflictsOf409(e: unknown): ConflictLine[] | null {
  if (!(e instanceof ApiError) || e.status !== 409) return null;
  return (e.details ?? []).map((d) => ({ path: d.field ?? '', fields: [], message: d.message ?? undefined }));
}
